import React from 'react';
import { Alert, AlertText } from '@fiverr-private/feedback';
import { Link } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Gql } from '@fiverr-private/dynamic_matching';
import pathfinder from '@fiverr-private/pathfinder';

interface BriefStatusProps {
  status: Gql.DmBriefStatus;
}

export const BriefStatus: React.FC<BriefStatusProps> = ({ status }) => {
  const communityStandardsUrl = pathfinder('community_standards');
  const i18nTemplates = { link: (text) => <Link href={communityStandardsUrl}>{text}</Link> };

  if (status === Gql.DmBriefStatus.Active) {
    return null;
  }

  if (status === Gql.DmBriefStatus.ClosedStale) {
    return (
      <Alert variant="neutral">
        <AlertText>
          <I18n k="brief_preview_drawer.person_brief.status.closed_stale" />
        </AlertText>
      </Alert>
    );
  }

  if (status === Gql.DmBriefStatus.ClosedFailedModeration) {
    return (
      <Alert variant="error">
        <AlertText>
          <I18n k="brief_preview_drawer.person_brief.status.closed_failed_moderation" templates={i18nTemplates} />
        </AlertText>
      </Alert>
    );
  }

  return null;
};
